import type { GuestFormValues } from './manualBookingRules';
import { fieldInput, ManualBookingStep, ManualField } from './ManualBookingStep';

interface Props {
  guest: GuestFormValues;
  onChange: <K extends keyof GuestFormValues>(field: K, value: GuestFormValues[K]) => void;
  /** Erst bekannt, wenn ein Apartment gewählt ist. */
  currency: string | null;
}

/** Schritte 2 und 3: Gast (Name und E-Mail Pflicht) sowie Preis und interne Notiz. */
export function GuestSteps({ guest, onChange, currency }: Props) {
  const text = (field: 'firstName' | 'lastName' | 'email' | 'phone' | 'notes') => ({
    value: guest[field],
    onChange: (event: { target: { value: string } }) => onChange(field, event.target.value),
    className: fieldInput,
  });
  return (
    <>
      <ManualBookingStep n={2} title="Gast" hint="Pflicht: Name und E-Mail">
        <div className="grid grid-cols-2 gap-2.5">
          <ManualField label="Vorname *">
            <input {...text('firstName')} autoComplete="off" />
          </ManualField>
          <ManualField label="Nachname *">
            <input {...text('lastName')} autoComplete="off" />
          </ManualField>
        </div>
        <div className="grid gap-2.5 sm:grid-cols-[1.4fr_1fr]">
          <ManualField label="E-Mail *">
            <input type="email" {...text('email')} placeholder="gast@example.de" />
          </ManualField>
          <ManualField label="Telefon · optional">
            <input type="tel" {...text('phone')} placeholder="+49 …" />
          </ManualField>
        </div>
      </ManualBookingStep>
      <ManualBookingStep
        n={3}
        title="Preis & Notiz"
        note="Interne Notizen bleiben intern und gehen an kein Buchungsportal."
      >
        <div className="grid gap-2.5 sm:grid-cols-[1fr_1.6fr]">
          <ManualField label={`Preis pro Nacht${currency ? ` (${currency})` : ''} *`}>
            <input
              type="number"
              step="0.01"
              min={0}
              inputMode="decimal"
              value={guest.nightlyRate}
              onChange={(event) => onChange('nightlyRate', event.target.value)}
              placeholder="118.00"
              className={fieldInput}
            />
          </ManualField>
          <ManualField label="Interne Notizen">
            <input {...text('notes')} placeholder="z. B. Ankunft nach 22 Uhr" />
          </ManualField>
        </div>
      </ManualBookingStep>
    </>
  );
}
